import React, { FC, useCallback } from 'react'
import s from './MapFiltersAside.module.sass'
import { MapButtonActionForAside } from '@widgets/Restaurant/Map/ui/MapButtonActionForAside'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { Title } from '@shared/ui/Typography/Title'
import { FilterOnceTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterOnceTemplate'
import {
  TypeFiltersByKeyOnce,
  TypeFiltersByKeyListButtons,
  TypeFilterByKeyListCheckboxes,
} from '@features/Restaurant/RestaurantFilters/model/types'
import { applyFilterAndUpdate, resetAllFilters } from '@features/Restaurant/RestaurantFilters/model/actions'
import { FilterIntegratedButtonsTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterButtonsTemplate/FilterIntegratedButtonsTemplate/FilterIntegratedButtonsTemplate'
import { FilterIntegratedListTemplate } from '@features/Restaurant/RestaurantFilters/ui/FilterListTemplate/FilterIntegratedListTemplate/FilterIntegratedListTemplete'
import FilterButtons from '@features/Restaurant/RestaurantFilters/ui/FilterButtons/FilterButtons'
import { EGG } from '@shared/api/analytics'
import { getFilterByType, getFilterSelected } from '@features/Restaurant/RestaurantFilters/helpers/helper'

interface Props {
  handleClose: () => void
}
export const MapFiltersAside: FC<Props> = ({ handleClose }) => {
  const dispatch = useAppDispatch()
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)

  const handleSendOutputData = useCallback(async () => {
    if (!stateFilters.ready) return
    await dispatch(applyFilterAndUpdate())
  }, [JSON.stringify(stateFilters)])

  const handleRemoveInner = useCallback(async () => {
    if (!stateFilters.ready) return
    await dispatch(resetAllFilters())
  }, [JSON.stringify(stateFilters)])

  const handleSaveInner = useCallback(async () => {
    if (!stateFilters.ready) return
    Object.keys(stateFilters.filters).forEach((typeFilter) => {
      const applyValue = getFilterByType(typeFilter)
      if (!applyValue) {
        return
      }
      EGG.common.filter_use_click({
        filter_apply_type: typeFilter,
        filters_apply: getFilterSelected(),
        filter_apply_value: getFilterByType(typeFilter),
      })
    })
    handleClose()
    await dispatch(applyFilterAndUpdate())
  }, [JSON.stringify(stateFilters)])

  return (
    <div className={s.wrap}>
      <MapButtonActionForAside onClick={handleClose} className={s.close} />

      <div className={s.card}>
        <Title sizes={'h3'} className={s.title}>
          Фильтры и сортировка
        </Title>

        <div className={s.buttons}>
          {(['hasBooking', 'openNow', 'afishaSelected'] as TypeFiltersByKeyOnce[]).map((typeFilter) => (
            <FilterOnceTemplate key={typeFilter} typeFilter={typeFilter} handleChange={handleSendOutputData} />
          ))}
        </div>

        {(['metro', 'kitchen'] as TypeFilterByKeyListCheckboxes[]).map((typeFilter) => (
          <FilterIntegratedListTemplate key={typeFilter} typeFilter={typeFilter} />
        ))}

        {(['rating', 'price'] as TypeFiltersByKeyListButtons[]).map((typeFilter) => (
          <FilterIntegratedButtonsTemplate key={typeFilter} typeFilter={typeFilter} />
        ))}

        <FilterIntegratedListTemplate key={'establishment'} typeFilter={'establishment'} />

        <FilterButtons className={s.submits} handleRemove={handleRemoveInner} handleSave={handleSaveInner} />
      </div>
    </div>
  )
}
